// Address Search
(function () {
    // Step 1 - Detect Address Style
    const selectAddressStyle = document.querySelector("[data-address-style]");
    if (!selectAddressStyle) return;

    function detectAddressStyle() {
        const searchAddressButtonQas = document.getElementById("searchAddressButtonQas");
        const searchAddressButtonBfo = document.getElementById("searchAddressButtonBfo");
        const disclaimerWrapper = document.querySelector(".contact-main-address-disclaimer-wrapper");
        const selectedValue = selectAddressStyle.value;

        if (selectedValue === "XX") {
            if (searchAddressButtonQas && searchAddressButtonBfo) {
                searchAddressButtonQas.style.display = "none";
                searchAddressButtonBfo.style.display = "block";
                disclaimerWrapper.style.display = "block";

                // Get references to the form elements
                const bfpoAddress1Input = document.querySelector('[data-bfo="address1-input"]');
                const bfpoAddress2Input = document.querySelector('[data-bfo="address2-input"]');
                const bfpoAddress3Input = document.querySelector('[data-bfo="address3-input"]');
                const bfpoAddress4Input = document.querySelector('[data-bfo="address4-input"]');
                const bfpoNumber = document.querySelector('[data-bfo="postcode-input"]');
                const bfpoCountry = document.querySelector('[data-bfo="country-input"]');
                const bfpoFullAddressInput = document.getElementById("postcode-search");
                const dataAddressTypeXX = document.querySelector('[data-address-type="XX"]');
                dataAddressTypeXX.classList.remove("hide");

                if (bfpoNumber.value === "" || bfpoNumber.value === "empty") {
                    bfpoNumber.value = "BFPO";
                }
                if (bfpoCountry.value === "") {
                    bfpoCountry.value = "XX";
                }

                console.log(bfpoNumber.value);

                // Function to update the fullAddress input
                function bfpoUpdateFullAddress() {
                    const address1 = bfpoAddress1Input.value || "";
                    const address2 = bfpoAddress2Input.value || "";
                    const address3 = bfpoAddress3Input.value || "";
                    const address4 = bfpoAddress4Input.value || "";
                    const bfpoNnumber = bfpoNumber.value || "";
                    bfpoFullAddressInput.value = `${address1}, ${address2}, ${address3}, ${address4}, ${bfpoNnumber}`;
                }

                searchAddressButtonBfo.addEventListener("click", function () {
                    bfpoUpdateFullAddress();
                });

                // // Add event listeners to the form elements
                bfpoAddress1Input.addEventListener("input", bfpoUpdateFullAddress);
                bfpoAddress2Input.addEventListener("input", bfpoUpdateFullAddress);
                bfpoAddress3Input.addEventListener("input", bfpoUpdateFullAddress);
                bfpoAddress4Input.addEventListener("input", bfpoUpdateFullAddress);
                bfpoNumber.addEventListener("input", bfpoUpdateFullAddress);
                bfpoCountry.addEventListener("input", bfpoUpdateFullAddress);

                if (!dataAddressTypeXX.classList.contains("hidden")) {
                    bfpoUpdateFullAddress();
                }
            }
        } else if (selectedValue === "GB") {
            if (searchAddressButtonQas && searchAddressButtonBfo) {
                searchAddressButtonBfo.style.display = "none";
                searchAddressButtonQas.style.display = "block";
                disclaimerWrapper.style.display = "block";

                // Get references to the form elements
                const address1Input = document.querySelector('[data-qas="address1-input"]');
                const address2Input = document.querySelector('[data-qas="address2-input"]');
                const address3Input = document.querySelector('[data-qas="address3-input"]');
                const cityInput = document.querySelector('[data-qas="city-input"]');
                const countySelect = document.querySelector('[data-qas="county-input"]');
                const postcodeInput = document.querySelector('[data-qas="postcode-input"]');
                const fullAddressInput = document.getElementById("postcode-search-qas");
                const dataAddressTypeGB = document.querySelector('[data-address-type="GB"]');
                dataAddressTypeGB.classList.remove("hide");

                // Function to update the fullAddress input
                function updateFullAddress() {
                    const address1 = address1Input.value || "*";
                    const address2 = address2Input.value || "*";
                    const address3 = address3Input.value || "*";
                    const city = cityInput.value || "*";
                    const county = countySelect.value !== "" ? countySelect.options[countySelect.selectedIndex].text : "*";
                    const postcode = postcodeInput.value || "*";

                    fullAddressInput.value = `${address1}, ${address2}, ${address3}, ${city}, ${county}, ${postcode}`;
                }

                searchAddressButtonQas.addEventListener("click", function () {
                    updateFullAddress();
                });
                // Add event listeners to the form elements
                address1Input.addEventListener("input", updateFullAddress);
                address2Input.addEventListener("input", updateFullAddress);
                address3Input.addEventListener("input", updateFullAddress);
                cityInput.addEventListener("input", updateFullAddress);
                countySelect.addEventListener("change", updateFullAddress);
                postcodeInput.addEventListener("input", updateFullAddress);

                if (!dataAddressTypeGB.classList.contains("hidden")) {
                    updateFullAddress();
                }
            }
        } else {
            disclaimerWrapper.style.display = "none";
        }
    }

    window.onload = detectAddressStyle;
    selectAddressStyle.onchange = detectAddressStyle;

    // Step 2 - Get Values from form inputs
    // Search Address Form QAS
    var qasForm = document.querySelector("#postcode-search-form-QAS");
    if (qasForm) {
        var submitButton = qasForm.querySelector('button[type="submit"]');
        var errorSpan = qasForm.querySelector(".address-error");
        submitButton.addEventListener("click", function (event) {
            var list = document.querySelector(".address-list-qas");
            var errorMessage = document.querySelector(".message-error");
            while (list.firstChild) {
                errorMessage.textContent = "";
                list.removeChild(list.firstChild);
            }
            event.preventDefault();
            var postcodeSearchInput = qasForm.querySelector('input[name="postcodesearch"]');
            var postcodesearch = postcodeSearchInput ? postcodeSearchInput.value : "";
            // Get the URL from the form's action attribute
            var formAction = qasForm.action;
            formAction += "?postcodesearch=" + encodeURIComponent(postcodesearch);
            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // Construct the form data
            var formData = new FormData();
            formData.append("postcodesearch", postcodesearch);
            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var addresses = JSON.parse(xhr.responseText);
                    const mainAddressElement = document.querySelector(".contact-main-address-element");
                    const addressSearchModal = document.querySelector(".address-search__modal");
                    if (mainAddressElement || addressSearchModal) {
                        const addressList = document.querySelector(".address-list");
                        const selectedAddressWrapper = document.querySelector(".selected-address-wrapper");
                        const addressInputs = {
                            address1: document.querySelector('[data-qas="address1-input"]'),
                            address2: document.querySelector('[data-qas="address2-input"]'),
                            address3: document.querySelector('[data-qas="address3-input"]'),
                            city: document.querySelector('[data-qas="city-input"]'),
                            county: document.querySelector('[data-qas="county-input"]'),
                            postcode: document.querySelector('[data-qas="postcode-input"]'),
                        };
                        function handleAddressSelection(event) {
                            const selectedIndex = Array.from(addressList.children).indexOf(event.target.parentNode);
                            const selected = addresses.QAPicklist.PicklistEntry[selectedIndex];
                            // Fill input fields with address data
                            addressInputs.address1.value = selected.QAAddress.AddressLine[0].Line;
                            addressInputs.address2.value = selected.QAAddress.AddressLine[1].Line;
                            addressInputs.address3.value = selected.QAAddress.AddressLine[2].Line;
                            addressInputs.city.value = selected.QAAddress.AddressLine[3].Line;
                            const countyText = selected.QAAddress.AddressLine[4].Line;
                            const countyOptions = addressInputs.county.options;
                            // Check if the county text matches any option in the select dropdown
                            const matchedOption = Array.from(countyOptions).find((option) => option.text === countyText);
                            if (matchedOption) {
                                // Set the matched option as selected in the select dropdown
                                matchedOption.selected = true;
                            } else {
                                // Select the first option in the select dropdown
                                addressInputs.county.selectedIndex = 0;
                            }
                            addressInputs.postcode.value = selected.QAAddress.AddressLine[5].Line;
                        }
                        addressList.addEventListener("click", function (event) {
                            if (event.target.classList.contains("select-address")) {
                                handleAddressSelection(event);
                            }
                        });
                        if (!addresses || !addresses.QAPicklist || !addresses.QAPicklist.PicklistEntry || addresses.QAPicklist.PicklistEntry.length === 0) {
                            const errorMessage = document.querySelector(".message-error");
                            errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            selectedAddressWrapper.style.display = "none";
                        } else {
                            var information = addresses.QAPicklist.PicklistEntry[0]["@Information"];
                            var warnInformation = addresses.QAPicklist.PicklistEntry[0]["@WarnInformation"];
                            // Check if both values are true
                            if (information === "true" && warnInformation === "true") {
                                var errorMessage = document.querySelector(".message-error");
                                errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            } else {
                                addresses.QAPicklist.PicklistEntry.forEach((address) => {
                                    const listItem = document.createElement("li");
                                    listItem.className = "address-item";
                                    const addressDetails = document.createElement("div");
                                    addressDetails.className = "address-details";
                                    addressDetails.textContent = address.PartialAddress;
                                    const selectButton = document.createElement("a");
                                    selectButton.className = "select-address btn";
                                    selectButton.textContent = "Select Address";
                                    selectButton.role = "button";
                                    listItem.appendChild(addressDetails);
                                    listItem.appendChild(selectButton);
                                    addressList.appendChild(listItem);
                                });
                                const buttons = document.querySelectorAll(".select-address");
                                // Add event listener to each button
                                buttons.forEach((button) => {
                                    button.addEventListener("click", () => {
                                        // Find the closest dialog element to the clicked button
                                        const dialog = button.closest("dialog");

                                        if (dialog) {
                                            // Close the dialog if it exists
                                            dialog.close();
                                        }
                                    });
                                });
                            }
                        }
                    }
                }
                //  else {
                //     const errorMessage = document.querySelector(".message-error");
                //     const selectedAddressWrapper = document.querySelector(".selected-address-wrapper");
                //     errorMessage.textContent = "No Addresses Found - API";
                //     selectedAddressWrapper.style.display = "none";
                // }
            };
            // Send the form data
            xhr.send(formData);
        });
        var postcodeSearchInput = qasForm.querySelector('input[name="postcodesearch"]');
        postcodeSearchInput.addEventListener("input", function () {
            errorSpan.textContent = "";
        });
    }

    // Search Address Form BFO
    var formBFO = document.querySelector("#postcode-search-form-BFO");
    if (formBFO) {
        var submitButton = formBFO.querySelector('button[type="submit"]');
        var errorSpanBfo = formBFO.querySelector(".address-error-bfo");
        submitButton.addEventListener("click", function (event) {
            const list = document.querySelector(".address-list-bfo");
            while (list.firstChild) {
                errorSpanBfo.textContent = "";
                list.removeChild(list.firstChild);
            }
            event.preventDefault();
            const bfpoAddress1Input = document.querySelector('input[data-bfo="address1-input"]');
            const bfpoAddress1 = bfpoAddress1Input ? bfpoAddress1Input.value : "";
            const bfpoAddress2Input = document.querySelector('input[data-bfo="address2-input"]');
            const bfpoAddress2 = bfpoAddress2Input ? bfpoAddress2Input.value : "";
            const bfpoNumber = document.querySelector('input[data-bfo="postcode-input"]');
            const bfpoNumberValue = bfpoNumber ? bfpoNumber.value.toString().replace(/\D/g, "") : "";
            const bfpoCountry = document.querySelector('[data-bfo="country-input"]');
            const countryValue = bfpoCountry.value !== "" ? bfpoCountry.options[bfpoCountry.selectedIndex].text : "";

            var postcodeSearchInput = formBFO.querySelector('input[name="postcodesearch"]');
            var postcodesearch = postcodeSearchInput ? postcodeSearchInput.value : "";

            // Get the URL from the form's action attribute
            var formAction = formBFO.action;

            formAction += "?country=" + encodeURIComponent(countryValue) + "&bfpo_number=" + encodeURIComponent(bfpoNumberValue) + "&address_line_2=" + encodeURIComponent(bfpoAddress2) + "&address_line_1=" + encodeURIComponent(bfpoAddress1);
            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // Construct the form data
            var formData = new FormData();
            formData.append("postcodesearch", postcodesearch);
            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var items = JSON.parse(xhr.responseText);

                    const mainAddressElement = document.querySelector(".contact-main-address-element");
                    const addressSearchModal = document.querySelector(".address-search__modal");
                    if (mainAddressElement || addressSearchModal) {
                        const addressList = document.querySelector(".address-list-bfo");
                        const selectedAddressWrapper = document.querySelector(".selected-address-wrapper-bfo");
                        const addressInputs = {
                            address4: document.querySelector('[data-bfo="address4-input"]'),
                            bfpo_number: document.querySelector('[data-bfo="postcode-input"]'),
                            bfpo_country: document.querySelector('[data-bfo="country-input"]'),
                        };

                        function handleAddressSelection(event) {
                            const selectedIndex = Array.from(addressList.children).indexOf(event.target.parentNode);
                            const selected = items.items[selectedIndex];
                            addressInputs.address4.value = selected.site_location + ", " + selected.post_code;
                            addressInputs.bfpo_number.value = "BFPO " + selected.bfpo_number;
                            addressInputs.bfpo_country.value = selected.country;
                            const countryText = selected.country;
                            const countryOptions = addressInputs.bfpo_country.options;

                            // Check if the county text matches any option in the select dropdown
                            const matchedOption = Array.from(countryOptions).find((option) => option.text === countryText);
                            if (matchedOption) {
                                matchedOption.selected = true;
                            }
                        }

                        addressList.addEventListener("click", function (event) {
                            if (event.target.classList.contains("select-address")) {
                                handleAddressSelection(event);
                            }
                        });

                        if (!items || !items.items || items.items.length === 0) {
                            const errorMessage = document.querySelector(".message-error-bfo");
                            errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            selectedAddressWrapper.style.display = "none";
                        } else {
                            items.items.forEach((item) => {
                                const listItem = document.createElement("li");
                                listItem.className = "address-item";

                                const addressDetails = document.createElement("div");
                                addressDetails.className = "address-details";

                                if (item.country === null || item.country === "null" || item.country === "") {
                                    addressDetails.textContent = "BFPO" + item.bfpo_number + ", " + item.site_location + ", " + item.post_code;
                                } else {
                                    addressDetails.textContent = "BFPO" + item.bfpo_number + ", " + item.site_location + ", " + item.post_code + ", " + item.country;
                                }

                                const selectButton = document.createElement("a");
                                selectButton.className = "select-address btn";
                                selectButton.textContent = "Select Address";
                                selectButton.role = "button";

                                listItem.appendChild(addressDetails);
                                listItem.appendChild(selectButton);
                                addressList.appendChild(listItem);
                            });
                            const buttons = document.querySelectorAll(".select-address");
                            // Add event listener to each button
                            buttons.forEach((button) => {
                                button.addEventListener("click", () => {
                                    // Find the closest dialog element to the clicked button
                                    const dialog = button.closest("dialog");

                                    if (dialog) {
                                        // Close the dialog if it exists
                                        dialog.close();
                                    }
                                });
                            });
                        }
                    }
                }
                // else {
                //     const errorMessage = document.querySelector(".message-error-bfo");
                //     const selectedAddressWrapper = document.querySelector(".selected-address-wrapper-bfo");
                //     errorMessage.textContent = "No Addresses Found - API BFO";
                //     selectedAddressWrapper.style.display = "none";
                // }
            };
            // Send the form data
            xhr.send(formData);
        });
        var postcodeSearchInput = formBFO.querySelector('input[name="postcodesearch"]');
        postcodeSearchInput.addEventListener("input", function () {
            errorSpanBfo.textContent = "";
        });
    }
})();
